/* eslint-disable security/detect-object-injection */
import './CommentField.style.less'

import CommentFieldDialog from './components/CommentFieldDialog/CommentFieldDialog'
import { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { notificationTaskIdAtom } from '@/jotai/notification.jotai'
import { isEmptyValue } from '@/utils/common'

interface Prop {
  label: string
  taskId: string
  data: any
}

export function CommentField(prop: Prop) {
  const { label, taskId, data } = prop
  const [visible, setvisible] = useState(false)

  const [notificationTask, setNotificationTask] = useAtom(
    notificationTaskIdAtom
  )

  useEffect(() => {
    if (
      notificationTask.taskId == taskId &&
      !isEmptyValue(notificationTask.commentId)
    ) {
      setvisible(true)
    }
    return () => {
      setNotificationTask(null)
    }
  }, [])

  const handleClick = () => {
    setvisible(true)
  }

  const handleClose = () => {
    setvisible(false)
  }

  return (
    <div className="comment-field-container">
      <button
        type="button"
        className="ant-btn ant-btn-link"
        onClick={() => handleClick()}
      >
        <div className="label-name">Comments</div>
      </button>
      {visible && (
        <CommentFieldDialog
          data={data}
          visible={true}
          label={label}
          taskId={taskId}
          onClose={() => handleClose()}
        />
      )}
    </div>
  )
}
